import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Job from './Job.js';


export default class SpaceWiseJobs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checkedAll: false,
			selectedJobs: [],
			jobs: []
		}
		this.jobActionPerformed = this.jobActionPerformed.bind(this);
	}

	componentWillMount() {
		this.setState({checkedAll:this.props.space.checkedAll, jobs: this.props.space.jobs});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.space.spaceName !== this.props.space.spaceName) {
	       	this.setState({
				jobs: this.props.space.jobs
			})
	    }
	}

	//<!-----------------------------  Action is perfomed on All Check -----------------------------!>
	handleAllCheckChange() {
		var val = true;
		var jobs = this.state.jobs;
		var selectedJobs = [];
		if(this.props.space.checkedAll) {
			val = false;
		}
		if(val) {
			for(let i in jobs) {
				jobs[i].checked = true;
				selectedJobs.push(jobs[i]);
			}
		} else {
			for (let i in jobs) {
				jobs[i].checked = false;
			}
			selectedJobs = [];
		}
		this.setState({
			jobs: jobs,
			selectedJobs: selectedJobs
		});
		this.props.checkOperation(selectedJobs, this.props.space.spaceName, val);
	}

	//<!----------------------------- Some action is perfomed on Job -----------------------------!>
	jobActionPerformed(job) {
		var selectedJobs = this.state.selectedJobs;
		var checkedAll = this.state.checkedAll;
		if(job.checked) {
			selectedJobs.push(job);
		} else {
			for(let i in selectedJobs) {
				if(selectedJobs[i].inventoryMovementRequestIds === job.inventoryMovementRequestIds) {
					selectedJobs.splice(i,1);
					checkedAll = false;
					break;
				}
			}
		}
		this.setState({selectedJobs: selectedJobs, checkedAll: checkedAll});
		this.props.checkOperation(selectedJobs, this.props.space.spaceName, false);
  	}

  	//<!----------------------------- Get All the Jobs data to show -----------------------------!>
	getJobs(jobs) {
	  	var jobsData = jobs.map((job, index) => {
	  		if(job.checked === undefined) {
	  			job.checked = false;
	  		}
	  		return (
	  			<div key={index}>
	  				<Job job={job} jobActionPerformed={this.jobActionPerformed}/>
	  			</div>
	  		);
	  	});
	  	return jobsData;
  	}
  	
	render() {
		return(
			<div className="putaway-pallet-outer">
	  			<div>
	  				<div style={{paddingLeft:'15px'}}>
	  					<Checkbox checked={this.props.space.checkedAll} onChange={this.handleAllCheckChange.bind(this)} value="checkedG" classes={{root:'cstmCheckBox',checked:'greenChecked'}}/> <span style={{marginLeft:'20px',lineHeight:'22px',fontSize:'17px'}}>{this.props.space.spaceName}</span>
	  				</div>
	  				<div>
	  					{this.getJobs(this.props.space.jobs)}
	  				</div>
	  			</div>
  			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/SpaceWiseJobs.js